export var RCE_FILE_DOWNLOAD_WILL_BEGIN_SHORTLY = 'file-download-will-begin-shortly';
export var RCE_FILE_TOO_BIG = 'file-too-big';
export var RCE_FILE_UPLOAD_LIMITED = 'file-upload-limited';
export var RCE_FILE_UPLOAD_FAILURE = 'file-upload-failure';
